<script>
  import PartialCircleElementTorte from "./PartialCircleElementTorte.svelte";
  import { dict_to_sum, tausender_trenner } from "./UtilsBalkenProgress.svelte";

  export let months;
  export let mprt_countries_dict;
  export let mprt_basis_dict;
  export let adressable_market_size_charts_dict;
  export let laender_dict;
  export let marketing_start_date;

  export let lead_or_boli;

  let country_hide_dict = false;

  $: {
    laender_dict;

    if (laender_dict) {
      let tmp_dict = {};

      laender_dict.forEach((element) => {
        tmp_dict[element["short"]] = false;
      });

      country_hide_dict = tmp_dict;
    }
  }

  function toggle_hide(country) {
    country_hide_dict[country] = !country_hide_dict[country];
  }

  function month_format(month) {
    var split = month.split("-");
    return split[1] + "/" + split[0].substring(2, 4);
  }

  function get_width_percentage(months) {
    if (months.length < 12) {
      return 80 / 14;
    }

    return 80 / (months.length + 2);
  }
</script>

{#if country_hide_dict}
  <div class="card h-100 green-border" style="width: {months.length > 12 ? 150 : 100}%;">
    <div class="card-header">
      <h5 class="card-title">Market progress report</h5>
      <div>
        <div class="row green-border" style="margin:auto; padding: 10px; background-color: #fbfcfb;">
          <div class="col-2" style="font-size:10px;">Show report for:</div>
          <div class="col-10" style="font-size:10px;">
            <div class="row">
              <label style="font-weight: 600;"
                ><input type="radio" bind:group={lead_or_boli} id="selcec_leads_boli14" name="leads4" value={1} />&nbsp;New Leads</label
              ><br />
            </div>
            <div class="row">
              <label style="font-weight: 600;"
                ><input type="radio" bind:group={lead_or_boli} id="selcec_leads_boli24" name="boli4" value={2} />&nbsp;Active Boluses</label
              ><br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="margin-right: 20px;">
      {#each laender_dict as land_eintrag, country_index}
        {#if land_eintrag["checked"]}
          <div class="mouseover" on:click={toggle_hide(land_eintrag["short"])} style="width:150px">
            {#if !country_hide_dict[land_eintrag["short"]]}
              ▲
            {:else}
              ▼
            {/if}
            {land_eintrag["short"]}
          </div>
          <div
            class={country_hide_dict[land_eintrag["short"]] ? "hiddenClass" : "row"}
            style="padding-bottom: {country_hide_dict[land_eintrag['short']] ? 0 : 50}px; z-index:{country_index};"
          >
            <table style="{country_hide_dict[land_eintrag['short']] ? 'visibility:  collapse;' : ''}; width:100%;">
              <colgroup>
                <col span="1" style="width: {months.length > 12 ? 5 : 10}%;" />
                <col span="1" style="width: {months.length > 12 ? 5 : 10}%;" />
                <col span="1" style="width: {get_width_percentage(months)}%;" />

                {#each months as monats_label, index}
                  <col span="1" style="width: {get_width_percentage(months)}%;" />
                {/each}

                <col span="1" style="width: {get_width_percentage(months)}%;" />
              </colgroup>
              <tr>
                <th />
                <th />
                <th style="text-align: center">
                  <div
                    style="height: 35px;
            margin-left: 5px; margin-right: 5px; font-size:9px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
                  >
                    <span>Median {marketing_start_date.getFullYear() - 1} p.m.</span>
                  </div>
                </th>

                {#each months as monats_label, index}
                  <th style="text-align: center">
                    <div
                      style="height: 35px;background-color: #f2f2f2; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
                    >
                      <span>{month_format(monats_label)}</span>
                    </div>
                  </th>
                {/each}

                <th style="text-align: center">
                  <div
                    style="height: 35px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
                  >
                    <span>Total</span>
                  </div>
                </th>
              </tr>

              <tr style="vertical-align: bottom; ">
                <td rowspan="5" style="height: 0px;">
                  <div style="margin-left:30px; height:100px;">
                    <PartialCircleElementTorte
                      second_position={true}
                      ist_lead_table={true}
                      winkel_innen={adressable_market_size_charts_dict[land_eintrag["short"]]["AMS_percentage"]}
                      winkel_outer={adressable_market_size_charts_dict[land_eintrag["short"]]["AMT_percentage"]}
                      number={18800 + country_index}
                      radius={land_eintrag["radius"]}
                    />
                  </div>
                </td>

                <td style="text-align:left;">New Leads</td>

                <td>{tausender_trenner(mprt_basis_dict[land_eintrag["long"]])}</td>

                {#each months as monats_label, index}
                  <td>{tausender_trenner(mprt_countries_dict[land_eintrag["long"]][monats_label])}</td>
                {/each}

                <td> {tausender_trenner(dict_to_sum(mprt_countries_dict[land_eintrag["long"]]))}</td>
              </tr>
            </table>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}

<style>
  tr {
    text-align: right;
  }

  td {
    font-size: 12px;
  }

  .mouseover {
    cursor: pointer;
  }

  .hiddenClass {
    max-height: 0;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    transition: max-height 0.5s ease-in;
  }

  .shownClass {
    max-height: auto;

    opacity: 1;
    transition: max-height 0.5s ease-in;
    transition: opacity 0.5s ease-in;
  }

  .green-border {
    /*background-color: #fbfcfc;*/
    border-width: 0.25px;
    border-style: solid;
    border-color: #afc5b9 !important;
  }
</style>
